import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-btn-mat-dialog-close",
  templateUrl: "./btn-mat-dialog-close.component.html",
  styleUrls: ["./btn-mat-dialog-close.component.scss"],
})
export class BtnMatDialogCloseComponent implements OnInit {
  constructor(private dialogRef: MatDialogRef<BtnMatDialogCloseComponent>) {}

  ngOnInit(): void {}

  close() {
    this.dialogRef.close();
  }
}
